var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1623_6323)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3252 10.375C10.6953 10.375 10.0912 10.6252 9.64582 11.0706C9.20042 11.516 8.9502 12.1201 8.9502 12.75V18.45C8.9502 19.0799 9.20042 19.684 9.64582 20.1294C10.0912 20.5748 10.6953 20.825 11.3252 20.825H16.0752C16.7051 20.825 17.3092 20.5748 17.7546 20.1294C18.2 19.684 18.4502 19.0799 18.4502 18.45V12.75C18.4502 12.1201 18.2 11.516 17.7546 11.0706C17.3092 10.6252 16.7051 10.375 16.0752 10.375H11.3252ZM21.475 11.9045L19.4002 13.5984V17.6026L21.475 19.2936C21.5447 19.3505 21.6292 19.3864 21.7185 19.3971C21.8078 19.4078 21.8984 19.393 21.9796 19.3543C22.0608 19.3155 22.1294 19.2546 22.1773 19.1784C22.2252 19.1022 22.2505 19.014 22.2502 18.924V12.274C22.2501 12.1842 22.2246 12.0963 22.1765 12.0204C22.1285 11.9445 22.0599 11.8838 21.9787 11.8453C21.8976 11.8068 21.8072 11.7922 21.718 11.803C21.6289 11.8138 21.5446 11.8496 21.475 11.9064V11.9045Z",
    fill: "#9EC6C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1623_6323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVc);
export default __webpack_public_path__ + "static/media/vc.d79c4b72d7205abe9fb9f179915929b7.svg";
export { ForwardRef as ReactComponent };